import { render, staticRenderFns } from "./AuthorityBadge.vue?vue&type=template&id=d4b933fe&scoped=true&"
import script from "./AuthorityBadge.vue?vue&type=script&lang=js&"
export * from "./AuthorityBadge.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityBadge.vue?vue&type=style&index=0&id=d4b933fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b933fe",
  null
  
)

export default component.exports